<template>
  <div id="reporting-main-section-left-column" class="reporting-main-section-left-column flex-grow-1">

    <el-tabs v-model="selectedTab" type="border-card" v-if="results">
      <el-tab-pane label="Tickets" name="tickets">
        <div class="pt-2">
          <reporting-metrics v-if="metrics"></reporting-metrics>
          <tickets-reporting-table v-if="results"></tickets-reporting-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Ticket Analytics" name="ticket-analytics">
        <ticket-analytics></ticket-analytics>
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Agent Analytics" name="agent-analytics">
        <div class="pt-0">
          <agent-analytics></agent-analytics>
        </div>
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Expenses" name="expenses">
          <expense-analytics></expense-analytics>
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Timeline" name="timeline">
        <timeline-analytics></timeline-analytics>
      </el-tab-pane>
    </el-tabs>


    <div class="p-3" v-if="!results">
      <div class="alert alert-info">
        Please select your filters and click run report.
      </div>
    </div>

  </div>
</template>

<script>
import TicketsReportingTable from "./LeftColumn/TicketsReportingTable";
import ReportingMetrics from "./LeftColumn/ReportingMetrics";
import AgentAnalytics from "./LeftColumn/AgentAnalytics";
import TicketAnalytics from "./LeftColumn/TicketAnalytics";
import {mapGetters} from "vuex";
import ExpenseAnalytics from './LeftColumn/ExpenseAnalytics.vue';
import TimelineAnalytics from './LeftColumn/TimelineAnalytics.vue';

export default {
  name: "ReportingMainSectionLeftColumn",
  components: {TicketsReportingTable, ReportingMetrics, AgentAnalytics, TicketAnalytics, ExpenseAnalytics, TimelineAnalytics},
  data() {
    return {
      selectedTab: 'tickets'
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      results: 'results',
      metrics: 'metrics'
    })
  }
}
</script>

<style scoped lang="scss">
.reporting-main-section-left-column {
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  .el-tabs {
    height: 100%;
    border: 0;
  }

  .el-tabs--border-card {
    border-right: 1px solid #E4E7ED;
    box-shadow: none !important;
  }
}
</style>